import { DATA_TABLE_META } from '../constants';
import { ITableMeta } from '../types';

export function buildTableMeta(
  dataTableId: string | null,
  lapsedDays: number | undefined,
  retiredDays: { from: number; to: number | undefined } | undefined
): ITableMeta {
  if (dataTableId && DATA_TABLE_META[dataTableId]) {
    return DATA_TABLE_META[dataTableId];
  }
  if (lapsedDays) {
    return {
      title: `Lapsed Donors (>${lapsedDays} Days)`,
      description: `Donors needing outreach — last donation more than ${lapsedDays} days ago.`,
      iconColor: '#f31a25',
    };
  }
  if (retiredDays) {
    const rangeLabel = retiredDays.to
      ? `${retiredDays.from}-${retiredDays.to} days ago`
      : `${retiredDays.from}+ days ago`;
    return {
      title: `Retired Donors (Unresponsive) — ${retiredDays.from}-${
        retiredDays.to ?? '+'
      } Days`,
      description: `Retired (Unresponsive) donors who transitioned to Retired status ${rangeLabel}.`,
      iconColor: '#f31a25',
    };
  }
  return {
    title: (dataTableId ?? '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase()),
    description: 'Donor list details',
    iconColor: '#1565c0',
  };
}
